import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';

const RAW_API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const API_BASE = RAW_API.replace(/\/api\/?$/, '');

export default function MyQRCode() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);

  useEffect(() => {
    api.get('/accounts/profile/').then(res => setProfile(res.data)).finally(() => setLoading(false));
  }, []);

  const generateQR = async () => {
    setGenerating(true);
    try {
      const res = await api.post('/accounts/profile/generate-qr/');
      setProfile({ ...profile, qr_code: res.data.qr_code_url });
      toast.success('QR Code generated!');
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || 'Failed to generate QR code.';
      toast.error(detail);
    } finally {
      setGenerating(false);
    }
  };

  if (loading) return <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0B5D1E] mx-auto mt-20"></div>;

  const qrUrl = profile?.qr_code ? `${API_BASE}${profile.qr_code}` : null;

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">My QR Code</h1>

      <div className="bg-white rounded-xl shadow-sm border p-8 text-center">
        {qrUrl ? (
          <>
            <div className="bg-gray-50 inline-block p-6 rounded-xl mb-6">
              <img src={qrUrl} alt="Your QR Code" className="w-64 h-64" />
            </div>
            <p className="text-gray-600 mb-4">
              Scan this QR code to view your public profile.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href={qrUrl}
                download={`NIS_QR_${profile?.membership_number || 'member'}.png`}
                className="bg-[#0B5D1E] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#062E10] transition"
              >
                Download QR Code
              </a>
              <button
                onClick={generateQR}
                disabled={generating}
                className="border-2 border-[#0B5D1E] text-[#0B5D1E] px-6 py-2.5 rounded-lg font-semibold hover:bg-green-50 transition disabled:opacity-50"
              >
                {generating ? 'Regenerating...' : 'Regenerate'}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="w-64 h-64 mx-auto bg-gray-100 rounded-xl flex items-center justify-center mb-6">
              <span className="text-6xl text-gray-300">📱</span>
            </div>
            <p className="text-gray-500 mb-6">You haven't generated your QR code yet.</p>
            <button
              onClick={generateQR}
              disabled={generating}
              className="bg-[#0B5D1E] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#062E10] transition disabled:opacity-50"
            >
              {generating ? 'Generating...' : 'Generate My QR Code'}
            </button>
          </>
        )}
      </div>

      <div className="mt-6 bg-blue-50 rounded-xl border border-blue-200 p-4">
        <h3 className="font-semibold text-blue-900 mb-2">About Your QR Code</h3>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• Your QR code links directly to your public member profile</li>
          <li>• Anyone scanning it can verify your membership status</li>
          <li>• Download and print it on your business card or ID</li>
          <li>• Regenerate anytime if you need a fresh code</li>
        </ul>
      </div>
    </div>
  );
}
